import React from 'react'
import { useSelector } from 'react-redux'

import Step from '../../../../../../../../features/components/Forms/StepForm/Step'
import LineItemGoogleAudienceFields from '../../../../../../LineItemForms/LineItemGoogleCreate/LineItemGoogleCreateForm/LineItemGoogleAudienceForm/LineItemGoogleAudienceFields'

import { selectedPartnershipSelector } from '../../../../../../../../modules/selectors/partnerships'

const AudiencesStep = ({ formik }) => {
  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const { rights_holder_name: rightsHolderName } = selectedPartnership

  return (
    <Step stepTitle={`Do you want to target ${rightsHolderName} audiences?`}>
      <LineItemGoogleAudienceFields formik={formik} />
    </Step>
  )
}

export default AudiencesStep
